import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Col, Row} from "react-bootstrap";
import {loadGeneralEnum} from '../actions/enums';
import {countIntakes, loadIntakes} from '../actions/intakes';
import {loadDog} from '../actions/dogs'
import {showModal} from "../actions/modal";
import {resetPage, showMessage} from '../actions';
import {defaultState} from '../reducers/paginate';
import {breadcrumbs} from "../utils";
import Intakes from "../components/intake/Intakes";

class IntakesPage extends Component {

	constructor(props) {
		super(props);

		this.handleFetchData = this.handleFetchData.bind(this);
		this.handleFetchEnums = this.handleFetchEnums.bind(this);
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps) {
	}

	componentWillUnmount() {
		this.props.resetPage();
	}

	handleFetchEnums(enums, filter = {}) {
		for (const i in enums) {
			if (enums.hasOwnProperty(i)) {
				this.props.loadGeneralEnum(enums[i], filter)
			}
		}
	}

	handleFetchData(filter) {
		this.props.loadIntakes(filter);
		this.props.countIntakes(filter);
	}

	render() {
		const {page, enums, session} = this.props;

		return (
			<div>
				<Row>
					<Col xs={8}>
						{breadcrumbs([{title: 'Příjmy'}])}
					</Col>
				</Row>
				<Intakes {...page} enums={enums} session={session}
					onLoadDog={this.props.loadDog}
					onFetchEnums={this.handleFetchEnums}
					onFetchData={this.handleFetchData}
				/>
			</div>
		)
	}
}

IntakesPage.propTypes = {
	page: PropTypes.object,
	enums: PropTypes.object,
	loadGeneralEnum: PropTypes.func.isRequired,
	loadIntakes: PropTypes.func.isRequired,
	countIntakes: PropTypes.func.isRequired,
	loadDog: PropTypes.func.isRequired,
	showMessage: PropTypes.func.isRequired,
	resetPage: PropTypes.func.isRequired,
	session: PropTypes.object.isRequired,
	showModal: PropTypes.func.isRequired
};


const mapStateToProps = (state, ownProps) => {
	const {
		pagination: {intakes},
		enums,
		session
	} = state;

	const page = intakes[0] || defaultState;

	return {
		page,
		enums,
		session
	}
};

export default connect(mapStateToProps, {
	loadGeneralEnum,
	loadIntakes,
	countIntakes,
	loadDog,
	showMessage,
	resetPage,
	showModal
})(IntakesPage)



// WEBPACK FOOTER //
// ./src/containers/IntakesPage.js